import CuratedLists from './CuratedLists';
import FeaturedBikes from './FeaturedBikes';
// import FindPartsForYourBikeCTA from './FindPartsForYourBikeCTA';
import GetTheAppCTA from './GetTheAppCTA';
import Highlights from './Highlights';
import HomepageHeader from './Home/components/HomepageHeader';
import MainBanner from './MainBanner';
import MTBCTA from './MTBCTA';
import SaleBanner from './SaleBanner';
import SeeWhatOurCustomersSay from './SeeWhatOurCustomersSay';
import SellersToFollow from './SellersToFollow';
import SellOnMxLockerCTA from './SellOnMxLockerCTA';

export {
  CuratedLists,
  FeaturedBikes,
  // FindPartsForYourBikeCTA,
  GetTheAppCTA,
  Highlights,
  HomepageHeader,
  MainBanner,
  MTBCTA,
  SaleBanner,
  SeeWhatOurCustomersSay,
  SellersToFollow,
  SellOnMxLockerCTA,
};
